import React, { useEffect, useState } from 'react'
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import PaymentFailedComponent from '../../Components/PaymentFailedComponent/PaymentFailedComponent';



const PaymentFailed = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div style={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>

        <Header />
        <PaymentFailedComponent />
        <Footer />
      </div>
    </>
  )
}

export default PaymentFailed
